<template>
  <div>
    <NavBar />

    <b-modal
      id="create"
      size="lg"
      title="NOVO CERTIFICADO"
      hide-footer
      no-close-on-backdrop
      @shown="modalCreateOnShow"
    >
      <b-form @submit.prevent="create">
        <div class="row">
          <div class="col-md-6 pt-0 pb-0">
            <label-required-field label="rest_home_id" />
            <select
              v-model="rest_home_id"
              class="form-control"
              @change="handleChangeRestHomeId"
            >
              <option value="">SELECIONE...</option>
              <option
                v-for="(item, key) in restHomes"
                :key="key"
                :value="item.id"
              >
                ({{ item.id }}) {{ item.name }}
              </option>
            </select>
          </div>
          <div class="col-md-6 pt-0 pb-0">
            <label-required-field label="user_id" />
            <select
              v-model="user_id"
              class="form-control"
              :disabled="!rest_home_id"
            >
              <option value="">SELECIONE...</option>
              <option v-for="(item, key) in users" :key="key" :value="item.id">
                [{{ item.id }}] {{ item.name }} - {{ item.email }} ({{
                  item.cpf
                }})
              </option>
            </select>
          </div>
          <div class="col-md-6 pt-0 pb-0">
            <label-required-field label="compartimento_uuid" />
            <input
              v-model="compartimento_uuid"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-6 pt-0 pb-0">
            <label-required-field label="uuid" />
            <input v-model="uuid" type="text" class="form-control" />
          </div>
          <div class="col-md-6 pt-0 pb-0">
            <label-required-field label="type" />
            <select v-model="type" class="form-control">
              <option value="">SELECIONE...</option>
              <option value="NORMAL">NORMAL</option>
              <option value="ICP_BRASIL">ICP BRASIL</option>
            </select>
          </div>
          <div class="col-md-6 pt-0 pb-0">
            <label-required-field label="status" />
            <select v-model="status" class="form-control">
              <option value="">SELECIONE...</option>
              <option value="ATIVO">ATIVO</option>
            </select>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <label-required-field label="certificate" />
            <textarea
              v-model="certificate"
              rows="3"
              class="form-control"
            ></textarea>
          </div>
          <div class="col-md-12">
            <errors-messages :errors="createErrors" />
          </div>
          <div class="col-md-12 pt-0 pb-0 text-right">
            <v-btn
              :disabled="loadingCreate"
              :loading="loadingCreate"
              type="submit"
              class="v-success"
            >
              <i class="fa fa-check mr-1"></i> SALVAR
            </v-btn>
          </div>
          <div class="col-md-12 pt-0 pb-0">
            <warning-required-fields />
          </div>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="view" title="CERTIFICADO" hide-footer>
      <b-form @submit.prevent="update">
        <warning-required-fields />
        <errors-messages :errors="updateErrors" />
        <b-row>
          <b-col class="text-right">
            <v-btn class="v-danger ml-1" @click="remove">
              <i class="fa fa-times-circle mr-1"></i> Apagar
            </v-btn>
            <v-btn type="submit" class="v-success ml-1">
              <i class="fa fa-check mr-1"></i> Salvar
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-overlay :show="loading" opacity="0.99">
      <b-container class="shadow rounded">
        <b-row>
          <b-col cols="auto">
            <v-btn class="v-primary" v-b-modal.create>
              <i class="fa fa-plus mr-1"></i> NOVO
            </v-btn>
          </b-col>
          <b-col cols="auto">
            <h4 class="my-1">CERTIFICADOS</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="PESQUISAR..."
              single-line
              hide-details
              @input="paginate"
            />
          </b-col>
        </b-row>
        <v-data-table
          dense
          :headers="headers"
          :items="data"
          :footer-props="{
            'items-per-page-options': [25, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          :options.sync="options"
          :server-items-length="total"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              class="v-primary"
              small
              @click="$bvModal.show(`details-${item.id}`)"
              >DETALHES</v-btn
            >
            <b-modal
              :id="`details-${item.id}`"
              title="CERTIFICADO"
              hide-footer
              no-close-on-backdrop
            >
              <div class="row">
                <div class="col-md-12 pt-0 pb-0 border">
                  <p class="m-0">rest_home_id</p>
                  <code>{{ item.rest_home_id }}</code>
                  <p class="m-0">
                    <small>({{ item.rest_home_name }})</small>
                  </p>
                </div>
                <div
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">user_id</p>
                  <code>{{ item.user_id }}</code>
                  <p class="m-0">
                    <small>({{ item.user_name }})</small>
                  </p>
                </div>
                <div
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">compartimento_uuid</p>
                  <code>{{ item.compartimento_uuid }}</code>
                </div>
                <div
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">uuid</p>
                  <code>{{ item.uuid }}</code>
                </div>
                <div
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">type</p>
                  <code>{{ item.type }}</code>
                </div>
                <div
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">status</p>
                  <code>{{ item.status }}</code>
                </div>
                <div
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">created_at</p>
                  <code>{{ item.created_at }}</code>
                </div>
                <div
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">updated_at</p>
                  <code>{{ item.updated_at }}</code>
                </div>
                <div
                  v-if="item.certificate"
                  class="
                    col-md-12
                    pt-0
                    pb-0
                    border-bottom border-left border-right
                  "
                >
                  <p class="m-0">certificate</p>
                  <code>{{ item.certificate }}</code>
                </div>
              </div>
            </b-modal>
          </template>
        </v-data-table>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import LabelRequiredField from "../templates/components/LabelRequiredField.vue";

import WarningRequiredFields from "../templates/components/WarningRequiredFields.vue";

import ErrorsMessages from "../templates/components/ErrorsMessages.vue";

import api from "../services/api";

import toast from "../components/ToastNotification";

export default {
  name: "Certificate",

  components: {
    NavBar,
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      total: 0,
      options: {},

      loading: false,
      loadingCreate: false,
      loadingUpdate: false,

      restHomes: [],
      users: [],

      search: "",

      headers: [
        // { text: "uuid", value: "uuid", sortable: false },
        { text: "ILPI", value: "rest_home_name", sortable: false },
        { text: "USUÁRIO", value: "user_name", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false, align: "end" },
      ],

      data: [],

      id: "",

      rest_home_id: "",
      user_id: "",
      compartimento_uuid: "",
      uuid: "",
      type: "",
      status: "",
      certificate: null,

      errors: [],
      createErrors: [],
      updateErrors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  async created() {
    await this.paginate();
    await this.getRestHomes();
  },

  methods: {
    async handleChangeRestHomeId() {
      try {
        this.users = [];

        let { rest_home_id } = this;

        if (rest_home_id) {
          let params = { rest_home_id };

          const response = await api.get("/admin/rest-home/list-users", {
            params,
          });

          const { data } = response.data;

          this.users = data;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getRestHomes() {
      try {
        const response = await api.get("/admin/rest-home/list");

        const { data } = response.data;

        this.restHomes = data;
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let { search } = this;

        let { page, itemsPerPage } = this.options;

        let params = { page, itemsPerPage, search };

        let response = await api.get("/user/certificate", { params });

        let { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async modalCreateOnShow() {
      this.rest_home_id = "";
      this.user_id = "";
      this.users = [];
      this.compartimento_uuid = "";
      this.uuid = "";
      this.type = "";
      this.status = "";
      this.certificate = "";
      this.errors = [];
      this.createErrors = [];
      this.updateErrors = [];
    },

    async create() {
      try {
        this.loadingCreate = true;

        let {
          rest_home_id,
          user_id,
          compartimento_uuid,
          uuid,
          type,
          status,
          certificate,
        } = this;

        let params = {
          rest_home_id,
          user_id,
          compartimento_uuid,
          uuid,
          type,
          status,
          certificate,
        };

        let response = await api.post("/user/certificate", params);

        let { error, errors, message } = response.data;

        if (error) {
          this.createErrors = errors;
        } else {
          this.paginate();
          this.createErrors = [];
          this.$bvModal.hide("create");
          toast(message, "success");
        }

        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async view(item) {
      this.id = item.id;
      this.$bvModal.show("view");
    },

    async update() {
      try {
        this.loading = true;

        let { id, rest_home_id } = this;

        let params = { id, rest_home_id };

        let response = await api.patch("/user/certificate", params);

        let { error, errors, message } = response.data;

        if (error) {
          this.updateErrors = errors;
        } else {
          this.paginate();
          this.updateErrors = [];
          this.$bvModal.hide("view");
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async remove() {
      try {
        this.loading = true;

        let { id } = this;

        let params = { id };

        let response = await api.delete("/user/certificate", { params });

        let { error, errors, message } = response.data;

        if (error) {
          this.updateErrors = errors;
        } else {
          this.paginate();
          this.updateErrors = [];
          this.$bvModal.hide("view");
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>